module.exports = __webpack_public_path__ + "img/area-comum-16.1f4c6845.png";